import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ScreenContainer from '../../components/ScreenContainer';
import Header from '../../components/Header';
import Button from '../../components/Button';
import { typography } from '../../styles/typography';
import colors from '../../styles/colors';
import CheckCircle from '../../components/CheckCircle';
import Note from '../../components/Note';
import { ANNUAL, MONTHLY } from '../../constans';
import { useSessionCheck } from '../../hooks/useSessionCheck';
import { t } from 'i18next';


export default function PlanSelection() {
  useSessionCheck()
  const [plan, setPlan] = useState(null);
  const navigate = useNavigate();

  const handleNext = () => {
    sessionStorage.setItem('plan', plan);
    navigate('/plan_confirmation');
  };

  function trans(key){
    return t("onb-web_subscribeplan_"+key)
  }

  return (
    <ScreenContainer style={style.container}>
      <Header withBackButton={false} />
      <div className={"scrollContainer"} style={style.scrollContainer}>

        <h1 className={"title title_m_24_medium"} >{trans(57)}</h1>
        <p className={"description body_15_regular mt-16"}>
          {trans(58)}
        </p>

        <label style={style.subtitle} className='mt-48'>{trans(59)}</label>
        <div style={plan == MONTHLY ? { ...style.card, ...style.cardOn } : style.card}>
          <div style={style.cardContent}>
            <div style={style.cardTitle}>{trans(60)}</div>
            <div style={style.price} className='mt-8'>{trans(61)}<span style={typography.body['15_regular']}> / {t('month').toLowerCase()}</span> </div>
            <div style={style.freeTrial} className='mt-12'>{trans(62)}</div>
          </div>
          <CheckCircle
            checked={plan == MONTHLY}
            onPress={() => setPlan(plan == MONTHLY ? null : MONTHLY)}
          />
        </div>

        <div style={plan == ANNUAL ? { ...style.card, ...style.cardOn } : style.card} className='mt-12'>
          <div style={style.cardContent}>
            <div style={style.cardTitle}>{trans(63)}</div>
            <div style={style.subtag}>{trans(64)}</div>
            <div style={style.price} className='mt-8'>{trans(65)} <span style={typography.body['15_regular']}> / {t('year_n').toLowerCase()}</span> </div>
            <div style={style.freeTrial} className='mt-12'>{trans(66)}</div>
            <div style={style.note}>{trans(67)}</div>
          </div>
          <CheckCircle
            checked={plan == ANNUAL}
            onPress={() => setPlan(plan == ANNUAL ? null : ANNUAL)}
          />
        </div>
        <Note className="mt-64">
          월 결제: $4.99 / 월 연 결제: $49 / 년 (약 18% 할인, 연 $10.9를 절약)<br/>
          - 30일 무료 체험이 종료되면, 선택하신 멤버십으로 자동 결제 및 전환됩니다.<br/>
          - 훈련 모드를 프로텍션 모드로 변경하지 않는 한 멤버십은 선택하신 결제 주기에 따라 자동 갱신됩니다.<br/>
          - 결제 완료 후 환불은 불가하며, 이미 결제된 기간은 남은 이용 기간 동안 계속 이용하실 수 있습니다.<br/>
          - 결제 주기 변경 시 환불은 불가하며, 남은 일자는 합산 처리됩니다.<br/>
          - 언제든 훈련 모드를 프로텍션 모드로 변경해 유료 멤버십을 해지할 수 있으며, 이미 결제된 기간 종료 후 자동 결제가 중단됩니다.
        </Note>

      </div>
      <div className="fixed-button-wrapper">
        <Button
          text={trans(68)}
          onClick={handleNext}
          disabled={plan == null}
          className={(plan != null ? "primary-on-button" : "primary-off-button") + " primary-button-text"}
        />
      </div>

    </ScreenContainer>

  );
}

const style = {
  container: {
    maxHeight: '100vh',
    overflow: 'hidden'
  },
  scrollContainer: {
    flex: 1,
    overflowY: 'scroll',
    paddingBottom: 80
  },
  card: {
    backgroundColor: '#111D22',
    border: '1px solid transparent',
    borderRadius: 20,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',
    padding: 20
  },
  cardOn: {
    backgroundColor: '#071A21',
    border: `1px solid ${colors.secondaryColor500}`
  },
  cardContent: {
    color: '#fff',
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  price: {
    ...typography.title.l_28_medium
  },
  freeTrial: {
    color: colors.mono300
  },
  note: {
    ...typography.body['15_regular'],
    color: colors.primaryColor100
  },
  subtitle: {
    ...typography.body['14_regular'],
    color: colors.mono300,
    width: '100%',
    marginBottom: 10
  },
  cardTitle: {
    ...typography.title.s_18_medium,
    color: '#FFF',
  },
  subtag: {
    ...typography.caption_12_regular,
    color: '#fff',
    backgroundColor: '#40788F',
    borderRadius: 20,
    padding: '3px 8px',
    marginTop: 16,
    alignSelf: 'flex-start'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px 18px'

  },
  contentTitle: {
    ...typography.body["15_medium"],
    color: '#fff',
    textAlign: 'center'
  },
  contentDescription: {
    ...typography.body["15_regular"],
    color: colors.mono300,
    marginTop: 6,
    textAlign: 'center'
  }
}